import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import Cookies from 'js-cookie';
import { JSEncrypt } from 'jsencrypt';
import globalConf from '@/config/globalConf';
import app from './modules/app';
import user from './modules/user';

Vue.use(Vuex);

const vuexCookie = new VuexPersistence({
  key: globalConf.persistName,
  restoreState: key => Cookies.getJSON(key),
  saveState: (key, state) => Cookies.set(key, state),
  modules: ['userModule'],
  filter: mutation => (mutation.type === 'SET_TOKEN' || mutation.type === 'SET_USER'),
});

const vuexSession = new VuexPersistence({
  key: globalConf.persistName,
  storage: window.sessionStorage,
  modules: ['appModule'],
  filter: mutation => (
    mutation.type === 'SET_COMPANY'
  ),
});

const store = new Vuex.Store({
  modules: {
    appModule: app,
    userModule: user,
  },
  getters: {
    getUser: (state) => {
      const crypt = new JSEncrypt();
      crypt.setPrivateKey(globalConf.privKey);
      const encryptUser = state.userModule.user || {};
      if (!encryptUser.id && !encryptUser.cellPhone) {
        return {};
      }
      return {
        id: crypt.decrypt(encryptUser.id || ''),
        name: crypt.decrypt(encryptUser.name || ''),
        token: crypt.decrypt(encryptUser.token || ''),
        type: crypt.decrypt(encryptUser.type || ''),
      };
    },
    getCompany: state => state.appModule.company || {},
  },
  plugins: [vuexCookie.plugin, vuexSession.plugin],
});

export default store;
